// extracted by mini-css-extract-plugin
module.exports = {"pt-system-customer-table":"pt-system-customer-table-f7630eee7c761aeedc6bfcf69b24a84c"};